<template>
   <div class="page-flatpage login-view">
    <main class="main">
      <div class="main-content">
        <article>
          <h1 class="font-bold">Mot de passe oublié</h1>
          <forgot class="login"></forgot>
        </article>
        </div>
    </main>
  </div>
</template>

<script>
import Forgot from '@/components/ForgotPassword'
export default {
    name: 'ForgotPass',
    components: {
        Forgot
    }

}
</script>
<style scoped>
article {
    height: 75vh;
}
.auth-login{
    background-size: 30vh;
    height: 50vh;
}
</style>